import { useState } from "react";
import useMerchantPortalAxios, {
  useMerchantPortalFormData,
} from "../utils/axios";
import { useDispatch } from "react-redux";
import { settingData } from "../features/BSLAccountSlice";
import useResponse from "../app/useResponse";
import axios from "axios";

const BSLAccountApi = () => {
  const [bslTransactionLoading, setBslTransactionLoading] = useState(false);
  // const [totalCount, setTotalCount] = useState(0);

  // const [totalNbOfPage, setTotalNbOfPage] = useState(0);

  const MerchantPortalAxios = useMerchantPortalAxios();
  const MerchantPortalAxiosFormData = useMerchantPortalFormData();

  const { successResponse, errorResponse } = useResponse();

  const [s2sData, setS2sData] = useState([]);
  const [s2sLoading, setS2sLoading] = useState(true);
  const [totalNbOfPage, setTotalNbOfPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);

  const dispatch = useDispatch();

  async function ApplyForIban() {
    await MerchantPortalAxios.post(`/v1/BankAccount/ApplyForIban`, {
      SessionID: sessionStorage.getItem("SessionID"),
    })
      .then((res) => {
        dispatch(
          settingData({
            field: "ApplyForIbanFlagCode",
            value: res?.data?.Payload.flagCode,
          })
        );
        if (res?.data?.Payload?.flagCode === 1) {
          successResponse(res?.data?.Payload);
        } else if (res?.data?.Payload?.flagCode === 2) {
          dispatch(
            settingData({
              field: "IBANBranches",
              value: res?.data?.Payload.Branches,
            })
          );
          dispatch(
            settingData({
              field: "VerificationRef",
              value: res?.data?.Payload.VerificationRef,
            })
          );
        }
      })
      .catch((err) => {
        errorResponse(err);
      });
  }

  async function GetBankAccountOverview() {
    await MerchantPortalAxios.post(`/v1/BankAccount/GetBankAccountOverview`, {
      SessionID: sessionStorage.getItem("SessionID"),
    })
      .then((res) => {
        dispatch(
          settingData({
            field: "GetBankAccountOverview",
            value: res?.data?.Payload?.BankAccountCurrenciesOverview,
          })
        );
      })
      .catch((err) => {});
  }

  async function GetBankAccountStatus() {
    await MerchantPortalAxios.post(`/v1/BankAccount/GetBankAccountStatus`, {
      SessionID: sessionStorage.getItem("SessionID"),
    })
      .then((res) => {
        dispatch(
          settingData({
            field: "bankAccountStatus",
            value: res?.data?.Payload.bankAccountStatus,
          })
        );
      })
      .catch((err) => {});
  }

  // async function GetSuyoolToBslTransfers(pageNb, dateFrom, dateTo) {
  //   await MerchantPortalAxios.post(`/v1/BankAccount/GetSuyoolToBslTransfers`, {
  //     SessionID: sessionStorage.getItem("SessionID"),
  //     page: pageNb,
  //     pageSize: 10,
  //     DateFrom: dateFrom,
  //     DateTo: dateTo,
  //   }).then((res) => {
  //     setS2sData(res.data.Payload.SuyoolToBslTransfers);
  //     if (res.data.Payload.SuyoolToBslTransfers?.length === 0) {
  //       setTotalNbOfPage(0);
  //       setTotalCount(0);
  //     } else {
  //       setTotalNbOfPage(res.data.Payload.SuyoolToBslTransfers[0].TotalPages);
  //       setTotalCount(res.data.Payload.SuyoolToBslTransfers[0].TotalCount || 0);
  //     }

  //     if (res.data.Payload.TemplateURL)
  //       sessionStorage.setItem(
  //         "S2sTransferTemplate",
  //         res.data.Payload.TemplateURL
  //       );
  //     setS2sLoading(false);
  //   });
  // }

  async function GetOutwardTransfers(pageNb, dateFrom, dateTo, type) {
    await MerchantPortalAxios.post(`/v1/BankAccount/GetOutwardTransfers `, {
      SessionID: sessionStorage.getItem("SessionID"),
      page: pageNb,
      pageSize: 10,
      DateFrom: dateFrom,
      DateTo: dateTo,
      Type: type,
    }).then((res) => {
      setS2sData(res.data.Payload.CorporateOutwardTransfers);
      if (res.data.Payload.CorporateOutwardTransfers?.length === 0) {
        setTotalNbOfPage(0);
        setTotalCount(0);
      } else {
        setTotalNbOfPage(
          res.data.Payload.CorporateOutwardTransfers[0].TotalPages
        );
        setTotalCount(
          res.data.Payload.CorporateOutwardTransfers[0].TotalCount || 0
        );
      }

      if (res.data.Payload.ProofOfPaymentUrl)
        sessionStorage.setItem(
          "S2sTransferTemplate",
          res.data.Payload.ProofOfPaymentUrl
        );
      setS2sLoading(false);
    });
  }

  async function PushOutwardTransfer(payload) {
    const form = new FormData();
    form.append("CurrencyID", String(payload?.CurrencyID ?? ""));
    form.append("Amount", String(payload?.Amount ?? ""));
    form.append(
      "BeneficiaryInfo.Name",
      payload?.BeneficiaryInfo.BeneficiaryName ?? ""
    );
    form.append(
      "BeneficiaryInfo.Country",
      payload?.BeneficiaryInfo.Country ?? ""
    );
    form.append("BeneficiaryInfo.City", payload.BeneficiaryInfo.City);
    form.append("BeneficiaryInfo.Street", payload.BeneficiaryInfo.Street);
    form.append("BeneficiaryInfo.Building", payload.BeneficiaryInfo.Building);
    form.append("BankInfo.IBANNumber", payload?.BankInfo.IbanNumber ?? "");
    form.append("BankInfo.Name", payload.BankInfo.BankName);
    form.append("BankInfo.Country", payload.BankInfo.BankCity);
    form.append("BankInfo.Swift", payload.BankInfo.Swift);
    form.append(
      "BankInfo.ReasonForTransfer",
      payload?.BankInfo.ReasonForTransfer ?? ""
    );
    form.append("AuthorizationCode", payload?.AuthorizationCode ?? "");
    form.append(
      "SessionID",
      payload?.SessionID ?? sessionStorage.getItem("SessionID") ?? ""
    );

    const pop = payload?.BankInfo?.ProofOfPayment;
    if (pop instanceof File || pop instanceof Blob) {
      form.append("BankInfo.ProofOfPayment", pop, pop.name || "proof");
    } else {
      form.append("BankInfo.ProofOfPayment", "");
    }
    try {
      const res = await MerchantPortalAxiosFormData.post(
        "/v1/BankAccount/PushOutwardTransfer",
        form
      );
      return res?.data?.Payload;
    } catch (error) {
      console.error("Error pushing outward transfer:", error);
      throw error;
    }
  }

  async function PushS2BTransfer(payload) {
    const form = new FormData();

    const normalizeDirection = (dir) => {
      if (dir == null) return "";
      if (typeof dir === "number") return String(dir);
      const s = String(dir).trim().toUpperCase();
      if (s === "IN") return "1";
      if (s === "OUT") return "2";
      return s;
    };

    form.append("CurrencyID", String(payload?.CurrencyID ?? ""));
    form.append("Amount", String(payload?.Amount ?? ""));
    form.append(
      "TransferDirection",
      normalizeDirection(payload?.TransferDirection)
    );
    form.append("AuthorizationCode", payload?.AuthorizationCode ?? "");
    form.append(
      "SessionID",
      payload?.SessionID ?? sessionStorage.getItem("SessionID") ?? ""
    );

    if (payload?.ProofOfPayment instanceof File) {
      form.append(
        "ProofOfPayment",
        payload.ProofOfPayment,
        payload.ProofOfPayment.name
      );
    } else {
      form.append("ProofOfPayment", "");
      console.warn("PushS2BTransfer: payload.ProofOfPayment is not a File.");
    }

    const res = await MerchantPortalAxios.post(
      "/v1/BankAccount/PushCorporateP2PTransfer",
      form,
      {
        headers: {
          // If your axios instance forces JSON, this override is necessary:
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return res?.data?.Payload;
  }

  const GetBslTransactionHistory = async (
    pageNb,
    dateFrom,
    dateTo,
    type,
    currencyId
  ) => {
    setBslTransactionLoading(true);
    await MerchantPortalAxios.post("/v1/BankAccount/GetBslTransactionHistory", {
      SessionID: sessionStorage.getItem("SessionID"),
      page: pageNb,
      PageSize: 10,
      DateFrom: dateFrom,
      DateTo: dateTo,
      Type: type,
      CurrencyId: currencyId,
    })
      .then((res) => {
        dispatch(
          settingData({
            field: "bslTransactionHistory",
            value: res.data.Payload.BslTransactions,
          })
        );
        if (res.data.Payload.BslTransactions.length === 0) {
          setTotalNbOfPage(0);
          setTotalCount(0);
        } else {
          setTotalNbOfPage(res.data.Payload.BslTransactions[0].TotalPages);
          setTotalCount(res.data.Payload.BslTransactions[0].TotalCount);
        }
        setBslTransactionLoading(false);
      })
      .catch((err) => {});
  };

  // const GetCorporateP2PTransfers = async (pageNb, dateFrom, dateTo, type, transferDirection) => {
  //   try {
  //     const res = await MerchantPortalAxios.post('/BankAccount/GetCorporateP2PTransfers', {
  //       SessionID: sessionStorage.getItem("SessionID"),
  //       page: pageNb,
  //       PageSize: 10,
  //       DateFrom: dateFrom,
  //       DateTo: dateTo,
  //       type: type,
  //       transferDirection: transferDirection
  //     })

  //     return res.data;
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  async function GetCorporateP2PTransfers(
    pageNb,
    dateFrom,
    dateTo,
    type,
    transferDirection
  ) {
    await MerchantPortalAxios.post("v1/BankAccount/GetCorporateP2PTransfers", {
      SessionID: sessionStorage.getItem("SessionID"),
      page: pageNb,
      PageSize: 10,
      DateFrom: dateFrom,
      DateTo: dateTo,
      type: type,
      transferDirection: transferDirection,
    }).then((res) => {
      setS2sData(res.data.Payload.CorporateP2PTransfers);
      if (res.data.Payload.CorporateP2PTransfers?.length === 0) {
        setTotalNbOfPage(0);
        setTotalCount(0);
      } else {
        setTotalNbOfPage(res.data.Payload.CorporateP2PTransfers[0].TotalPages);
        setTotalCount(
          res.data.Payload.CorporateP2PTransfers[0].TotalCount || 0
        );
      }

      if (res.data.Payload.TemplateURL)
        sessionStorage.setItem(
          "S2sTransferTemplate",
          res.data.Payload.TemplateURL
        );
      setS2sLoading(false);
    });
  }

  const SaveModificationRequestForm = async (payload) => {
    try {
      const response = await MerchantPortalAxios.post(
        "/v1/BankAccount/SaveModificationRequestForm",
        payload
      );
      return response.data.Payload;
    } catch (error) {
      console.error("Error saving modification request form:", error);
      throw error;
    }
  };

  const SubmitApplyForIban = async (payload) => {
    await MerchantPortalAxios.post(
      `/v1/BankAccount/SubmitApplyForIban`,
      payload
    )
      .then((res) => {
        successResponse(res?.data?.Payload);
      })
      .catch((err) => {
        errorResponse(err);
      });
  };

  const AccessToken = async () => {
    try {
      const res = await axios.post("https://suyool.com/api/create-token", {
        identifier: "trsbslb",
      });

      if (res) {
        sessionStorage.setItem("BSLAccessToken", res.data.token);
      }

    } catch (error) {
      console.error("Error fetching access token:", error);
    }
  };

  const DownloadTransferStatment = async (providerID, transferIdentifier) => {
    try {
      const token = sessionStorage.getItem("BSLAccessToken");
  
      const res = await MerchantPortalAxios.post(
        "https://gateway1.api.suyool.com/Transfers/Transfer/DownloadTransferStatement",
        { providerID, transferIdentifier },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      return res.data; 
    } catch (error) {
      console.error("Error downloading transfer statement:", error);
      throw error;
    }
  };


  const GetIBANCertificate = async () => {
    try {
      const res = await MerchantPortalAxios.post('/v1/BankAccount/GetIBANCertificate', {
        SessionID: sessionStorage.getItem("SessionID"),
      })

      return res.data.Payload;
    } catch (error) {
      console.error("Error fetching IBAN certificate:", error);
      throw error;
    }
  }
  
  return {
    ApplyForIban,
    GetBankAccountOverview,
    GetBankAccountStatus,
    // GetSuyoolToBslTransfers,
    PushOutwardTransfer,
    s2sData,
    s2sLoading,
    totalNbOfPage,
    totalCount,
    PushS2BTransfer,
    GetBslTransactionHistory,
    bslTransactionLoading,
    GetOutwardTransfers,
    GetCorporateP2PTransfers,
    SaveModificationRequestForm,
    SubmitApplyForIban,
    AccessToken,
    DownloadTransferStatment,
    GetIBANCertificate
  };
};

export default BSLAccountApi;
